import { CarouselOptions } from '@alliance/shared/carousel-gallery'

export const CAROUSEL_SELECTOR = '.ats-onboarding-categories-carousel'

export const CAROUSEL_OPTIONS: CarouselOptions = {
  selector: CAROUSEL_SELECTOR,
  duration: 300,
  easing: 'ease-out',
  perPage: 1,
  startIndex: 0,
  draggable: true,
  loop: true,
  showPaginator: true
}
